import './menu';
import './language-switch';
import './spec-list';

import 'svgxuse';
